import { createAppAsyncThunk } from 'src/store/utils/thunks';
import { wsMmSend } from '@skynet/data-ws-mm';
import { ReportCommands } from './types';
import type { ConfirmReportPayload, RequestReportPayload } from './types';

export const requestReport = createAppAsyncThunk(
  'reports/requestReport',
  (payload: RequestReportPayload, thunkApi) =>
    thunkApi.dispatch(
      wsMmSend({
        command: ReportCommands.GetReport,
        ...payload,
      }),
    ),
);

export const confirmReport = createAppAsyncThunk(
  'reports/confirmReport',
  (payload: ConfirmReportPayload, thunkApi) =>
    thunkApi.dispatch(
      wsMmSend({
        command: ReportCommands.SendReport,
        ...payload,
      }),
    ),
);

export const cancelReport = createAppAsyncThunk(
  'reports/cancelReport',
  (payload: ConfirmReportPayload, thunkApi) =>
    thunkApi.dispatch(
      wsMmSend({
        command: ReportCommands.CancelReport,
        ...payload,
      }),
    ),
);
